import { memo } from "react";

import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { RenderGroupRowCellProps } from ".";
import IacManagementGroupCell from "../../components/Table/Row/Group/Cell";

const IacManagementTableGroupRowCellResourceType = memo((props: RenderGroupRowCellProps) => {
  return (
    <IacManagementGroupCell {...props}>
      <TableCellEmpty />
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellResourceType.displayName =
  "IacManagementTableGroupRowCellResourceType";

export default IacManagementTableGroupRowCellResourceType;
